import styled from 'styled-components'

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  margin-bottom: ${props => props.theme.spacing.sp16};
`

export const LineItem = styled.div`
  display: flex;
  flex-direction: column;
  border: ${props => props.theme.stroke.emphasis} solid ${props => props.theme.colors.info.surface};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const LineItemBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
`

export const ProductRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ReasonBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.info.surface};
  padding: 6px ${props => props.theme.spacing.sp16};
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
`
